export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign in to continue."])},
        "userName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Username"])},
        "passWord": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
        "link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Don't have an account? Sign up here."])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Username or password is incorrect."])},
        "forgot": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forgot your password? Contact"])},
        "signIn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign in"])}
      },
      "nl-NL": {
        "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log in om door te gaan."])},
        "userName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersnaam"])},
        "passWord": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wachtwoord"])},
        "link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heb je geen account? Registreer hier."])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersnaam of wachtwoord is onjuist."])},
        "forgot": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wachtwoord vergeten? Contact"])},
        "signIn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inloggen"])}
      }
    }
  })
}
